import { useMemo } from 'react';

import type { SecurityFocusFull } from '@rtkwlf/track-public';

import { Stack } from '@packages/fenrir/components/stack';
import { Typography } from '@packages/fenrir/components/typography';

import {
  BlueprintsTable,
  BlueprintsTableColumn,
  parseBlueprintsForTable,
} from '../../../../components/tables/blueprints-table';
import { useSecurityJourneyTranslations } from '../../../../locales/use-security-journey-translations';

/* -------------------------------------------------------------------------------------------------
 * SecurityFocusUpcomingSpidrsTable
 * -----------------------------------------------------------------------------------------------*/
export type SecurityFocusBlueprintsTableProps = {
  focus: SecurityFocusFull;
  isOrganizationTierNonLegacy?: boolean | null;
};

export const SecurityFocusUpcomingSpidrsTable: React.FC<
  SecurityFocusBlueprintsTableProps
> = ({ focus, isOrganizationTierNonLegacy }) => {
  const { t } = useSecurityJourneyTranslations();

  const tableColumns = useMemo(() => {
    let tempTableColumns = [
      BlueprintsTableColumn.Name,
      BlueprintsTableColumn.Tier,
      BlueprintsTableColumn.TechnicalDomains,
      BlueprintsTableColumn.Technologies,
      BlueprintsTableColumn.Nist,
      BlueprintsTableColumn.Nist2,
      BlueprintsTableColumn.Cis,
      BlueprintsTableColumn.Subscriptions,
    ];
    if (isOrganizationTierNonLegacy) {
      return tempTableColumns;
    }
    tempTableColumns = tempTableColumns.filter((c) => c !== 'tier');
    return tempTableColumns;
  }, [isOrganizationTierNonLegacy]);

  const blueprints = parseBlueprintsForTable({
    blueprints: focus.blueprints,
  });

  return (
    <Stack
      spacing={3}
      width="100%"
      data-testid="security-focus-upcoming-spidrs-table"
    >
      <Typography variant="h3">
        {t('focusID.securityFocusUpcomingSpidrsTable.title')}
      </Typography>
      <BlueprintsTable
        blueprints={blueprints}
        tableColumns={tableColumns}
        emptyResultMessage={t(
          'focusID.securityFocusUpcomingSpidrsTable.noResultMessage.description',
        )}
      />
    </Stack>
  );
};
